export * from './baPageTop.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baPageTop/index.ts